import { WDD } from '../core/wdd.js';
import { swapImage } from '../utils/swapImage.js';

export function gallery() {
    const thumbs = WDD.el.querySelectorAll('.bp-gallery__thumb');
    const detailImgPicture = WDD.el.querySelector('.bp-detail__img picture');
    const detailImg = detailImgPicture?.querySelector('img');

    if (!thumbs.length || !detailImg) return;

    thumbs.forEach(thumb => {
        thumb.addEventListener('click', async () => {
            // 1. Check if button already has active class
            if (thumb.classList.contains('bp-gallery__thumb--active')) return;

            // 2. Remove active class from all thumbs
            thumbs.forEach(el => el.classList.remove('bp-gallery__thumb--active'));

            // 3. Add active class to clicked thumb
            thumb.classList.add('bp-gallery__thumb--active');

            // Get current active color
            const activeColor = WDD.el.querySelector('.bp-detail__color--active');
            const colorValue = activeColor?.getAttribute('data-img')?.toLowerCase() || 'red';

            // Get thumbnail number
            const thumbNumber = thumb.getAttribute('data-img');

            // Extract image directory path from thumbnail
            const thumbImg = thumb.querySelector('img');
            const thumbSrc = thumbImg.src;
            const imagePath = thumbSrc.substring(0, thumbSrc.lastIndexOf('/') + 1);

            // Build new image URL
            const newUrl = `${imagePath}${colorValue}-${thumbNumber}.png`;

            // Swap image with animation
            await swapImage(detailImg, newUrl);
        });
    });
}
